import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import {Map} from "./map";

export const Contact = (props) => {
    const defaultButtonText = "Contactez-nous"
    const {data} = props
    const currentYear = new Date().getFullYear();
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')
    const [text, setText] = useState(defaultButtonText)

    const handleName = (e) => {
        setName(e.target.value)
    }
    const handlePhone = (e) => {
        setPhone(e.target.value)
    }
    const handleMail = (e) => {
        setEmail(e.target.value)
    }
    const handleMessage = (e) => {
        setMessage(e.target.value)
    }
    const clearState = () => {
        setName('')
        setPhone('')
        setEmail('')
        setMessage('')
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        setText('Envoi en cours...')
        emailjs
            .sendForm("service_zh91swc", "template_pdua60g", e.target, "poFL_7HOC6vhx4BZA")
            .then(
                () => {
                    setText('Merci !')
                    setTimeout(() => {
                        setText(defaultButtonText)
                    }, 5000)
                    clearState();
                },
                (error) => {
                    console.log(error.text);
                    setText('Une erreur est survenue, merci de re-essayer.')
                    setTimeout(() => {
                        setText(defaultButtonText)
                    }, 5000)
                    clearState();
                }
            );
    };
    return (
        <div>
            <div id="contact">
                <div className="container">
                    <div className="section-title">
                        <h2>Contact</h2>
                    </div>
                    <div className="col-md-7">
                        <div className="row">
                            <form name="sentMessage" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                className="form-control"
                                                placeholder="Nom"
                                                required
                                                value={name}
                                                onChange={handleName}
                                            />
                                            <p className="help-block text-danger"></p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="phone"
                                                id="phone"
                                                name="phone"
                                                className="form-control"
                                                placeholder="Téléphone"
                                                required
                                                value={phone}
                                                onChange={handlePhone}
                                            />
                                            <p className="help-block text-danger"></p>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                className="form-control"
                                                placeholder="Adresse email"
                                                required
                                                value={email}
                                                onChange={handleMail}
                                            />
                                            <p className="help-block text-danger"></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                  <textarea
                                      name="message"
                                      id="message"
                                      className="form-control"
                                      rows="4"
                                      placeholder="Message"
                                      required
                                      onChange={handleMessage}
                                      value={message}
                                  />
                                    <p className="help-block text-danger"></p>
                                </div>
                                <div id="success"></div>
                                <button type="submit" className="btn btn-custom btn-lg">
                                    {text}
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="col-md-4 col-md-offset-1 contact-info">
                        <div className="contact-item">
                            <p>
                <span>
                  <i className="fa fa-map-marker"></i> Adresse
                </span>
                                {data ? data.address + ' ' + data.postcode + ' ' + data.city : "loading"}
                            </p>
                        </div>
                        <div className="contact-item">
                            <p>
                <span>
                  <i className="fa fa-phone"></i> Téléphone
                </span>{" "}
                                <a href={props.data ? "tel:" + props.data.phoneraw : ""} className="text-white">
                                    {props.data ? props.data.phone : "loading"}
                                </a> / <a href={props.data ? "tel:" + props.data.phone2raw : ""} className="text-white">
                                {props.data ? props.data.phone2 : "loading"}
                            </a>
                            </p>
                        </div>
                        <div className="contact-item">
                            <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                                <a href={props.data ? "mailto:"+props.data.email : ""} className="text-white">
                                    {props.data ? props.data.email : "loading"}
                                </a>
                            </p>
                        </div>
                        <div className="contact-item">
                            <p>
                <span>
                  <i className="fa fa-clock-o"></i> Horaires
                </span>{" "}
                            </p>
                            <ul>
                                <li><strong>Du Lundi au Vendredi</strong> : 9h-12h 13h-19h</li>
                                <li><strong>Samedi</strong> : 9h - 12h</li>
                                <li><strong>Dimanche</strong> : Fermé</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <Map data={props} />
                <div className="social">
                    <ul>
                        <li>
                            <a href={props.data ? props.data.facebook : "/"} target="_blank" rel="noreferrer">
                                <i className="fa fa-facebook"></i>
                            </a>
                        </li>
                        <li>
                            <a href={props.data ? props.data.instagram : "/"} target="_blank" rel="noreferrer">
                                <div className="contact-instagram">
                                    <img src="/img/instagram2.png" alt="Logo Instagram" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="footer">
                <div className="container text-center">
                    <p>
                        ©{currentYear} - L'atelier des pilotes - <a href="/mentions_legales_latelier_des_pilotes.pdf" target="_blank" rel="noreferrer" >
                            Mentions Légales
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};
